// @ts-nocheck
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import WebFormView from "@/components/webform/webform-view";
import { createFileRoute } from '@tanstack/react-router'

const WebForm = () => {
    const router = useRouter();
    const [o, setO] = useState<any>(null);
    const [k, setK] = useState<any>(null);
    const [api, setApi] = useState<any>(null);
    const [css, setCss] = useState<any>(null);
    const [form, setForm] = useState<any>(null);
    const [authenticated, setAuthenticated] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!router.isReady) return;
        const { origin, key, api: apiRaw, css: cssRaw } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch
        if (!origin || !key || !apiRaw) return;

        const decodedOrigin = atob(origin);
        const decodedKey = atob(key);
        const decodedApi = atob(apiRaw);
        const decodedCss = cssRaw ? atob(cssRaw) : '';

        setO(decodedOrigin);
        setK(decodedKey);
        setApi(decodedApi);
        setCss(decodedCss);

        fetch(`${decodedApi}/api/WebHook/WebForm?origin=${encodeURIComponent(decodedOrigin)}&key=${encodeURIComponent(decodedKey)}`)
            .then((r: any) => r.text())
            .then((data: any) => {
                const json = data.length ? JSON.parse(data) : null;
                const formData = json?.form;
                setForm(formData);
                setAuthenticated(formData !== null);
                setLoaded(true);
            });
    }, [router.isReady]);

    if (!loaded) return null;

    return <WebFormView o={o} k={k} authenticated={authenticated} form={form} api={api} css={css} />;
};

export default WebForm;

export const Route = createFileRoute('/webform')({ component: WebForm })
